var app = angular.module('leonardo');

var WorkFlowForm = function (
  $scope,
  $rootScope,
  $state,
  $filter,
  workflowOjb,
  WorkFlowService,
  AccountUserService,
  ngDialog,
  NotificationService,
  FormErrorsService,
  AccountService,
  AuthDataService,
  PermissionService,
  $controller,
  FieldSubgroupService,
  FilterService,
  TranslationService
) {
  $scope.action = $state.current.action;
  $scope.workflow = workflowOjb;
  $scope.tabsCollapsed = [];
  $scope.by_unit = $state.current.by_unit;
  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.accountUser = [];
  $scope.is_unit_turn = $scope.workflow ? $scope.workflow.is_unit_turn : false;
  $scope.fromwf = true;
  $scope.startDate = moment().format('YYYY-MM-DD');
  $scope.placeholder = moment().add(1, 'days').format('MMM D YYYY');
  $scope.propertiesList = [];
  $scope.fields_data = [];
  $scope.mode = 'workflow';
  $scope.field_data = {};
  $scope.filter_conditions = [];
  $scope.accountObj = null;

  // for enabling scheduling feature only for greystar
  let AccountIdsScheduleWF = [75,31];
  
  $scope.checkEnableScheduling = function (){
    if(AccountIdsScheduleWF.includes(AccountUserService.currentAccountUser.account)){
      return true;
    }
    return false;
  }

  $scope.by_unit_options = [
    { id: false, name: $filter('translate')('Standard') },
    { id: true, name: $filter('translate')('Unit turn') }
  ];
  $scope.type_unit_workflow_options = [
    { id: 1, name: $filter('translate')('Move In') },
    { id: 2, name: $filter('translate')('Pre Move Out') },
    { id: 3, name: $filter('translate')('Move Out') },
    { id: 4, name: $filter('translate')('Make Ready') }
  ];
  $scope.trigger_wfs_on_finish = [
    { id: true, name: $filter('translate')('Yes') },
    { id: false, name: $filter('translate')('No') }
  ];
  $scope.trigger_wf_types = [
    { id: 1, name: $filter('translate')('Move In') },
    { id: 2, name: $filter('translate')('Pre Move Out') },
    { id: 3, name: $filter('translate')('Move Out') },
    { id: 4, name: $filter('translate')('Make Ready') },
    { id: 5, name: $filter('translate')('Standard') }
  ];

  $scope.getLocaleLength = function (workflow) {
    let keys = Object.keys(workflow.locale);
    return keys.length;
  }

  $scope.initUsers = function (users) {
    var userIds = [];
    if (users) {
      var usersArray = angular.isArray(users) ? users : users.split(',');
      angular.forEach(usersArray, function (user) {
        if (user) {
          if (user.id) {
            userIds.push(user.id);
          } else {
            userIds.push(user);
          }
        }
      });
    }
    return userIds;
  };

  if ($scope.action === 'edit') {
    $scope.data = angular.copy($scope.workflow);
    $scope.data.trigger_wf_types = $scope.data.trigger_wf_types ? $scope.data.trigger_wf_types.join(',') : null;
    var templates_ids = [];
    angular.forEach($scope.data.templates, function (template) {
      templates_ids.push(template.id);
    });
    $scope.data.templates = templates_ids;
    $scope.data.account = $scope.workflow.account && $scope.workflow.account.id ? $scope.workflow.account.id : $scope.workflow.account;
    $scope.data.managed_by = $scope.workflow.managed_by && $scope.workflow.managed_by.id ? $scope.workflow.managed_by.id : $scope.workflow.managed_by;
    $scope.data.languages = ($scope.workflow.languages && $scope.workflow.languages.length > 0) ? $scope.workflow.languages.map(lang => lang.id) : ['2'],
    $scope.data.translation = ($scope.workflow.languages && $scope.workflow.languages.length > 0) ? true : false,
    $scope.data.created_in_language = $scope.workflow.created_in_language ? $scope.workflow.created_in_language : 'en',
    $scope.data.updated_in_language = $scope.workflow.updated_in_language ? $scope.workflow.updated_in_language : 'en',
    $scope.data.locale = $scope.workflow.locale,
    $scope.accountUser = AccountUserService.getAccountUser($scope.data.account);
    $scope.data.role_based = {
      roles: !isNull($scope.workflow.roles)
        ? $scope.workflow.roles.map(function (obj) {
            return obj.id;
          })
        : [],
      role_based_only: !isNull($scope.workflow.role_based_only) ? $scope.workflow.role_based_only : false,
    };
    $scope.data.seasonal = {
      from: null,
      to: null
    }
    $scope.data.properties_data = {
      properties : [],
      portfolios : []
    }
    $scope.unit_selected = [];
    $scope.all = false;
    $scope.units_exclude = [];
    if($scope.workflow.recurrence){
      $scope.data.seasonal = {
        from: $scope.workflow.date_from,
        to: $scope.workflow.date_to
      },
      $scope.data.recurrence = {
        type: !isNull($scope.workflow.recurrence_type) ? $scope.workflow.recurrence_type.toString() : null,
        recurrence: angular.copy($scope.workflow.recurrence)
      }
      $scope.field_data = $scope.workflow.fields,
      $scope.data.properties_data.properties = $scope.workflow.properties,
      $scope.data.properties_data.portfolios = $scope.workflow.portfolios,
      $scope.data.allow_recurrence = true;
      $scope.data.days_before_ai_creation = !isNull($scope.workflow.days_before_ai_creation) ? $scope.workflow.days_before_ai_creation : 0;
      if ($scope.by_unit && $scope.workflow.units && $scope.workflow.units.length > 0) {
        $scope.workflow.units.forEach(unit => {
          if(unit.isMarked){
            $scope.filter_conditions.push(unit)
          }
          else {
            if(unit.units === "all"){
              $scope.all = true;
              if(unit.unit_filters['number__icontains']){
                $scope.data.unit_number = unit.unit_filters['number__icontains'];
                FilterService.setFilter('unit_number', $scope.data.unit_number);
              }
              else if(unit.unit_filters['building__icontains']){
                $scope.data.building_number = unit.unit_filters['building__icontains'];
                FilterService.setFilter('building_number', $scope.data.building_number);
              }
              else if(unit.unit_filters['unit_type']){
                $scope.unit_type = unit.unit_filters['unit_type'];
                FilterService.setFilter('unit_type', $scope.data.unit_type);
              }
            }
            else {
              $scope.unit_selected = unit.units;
            }
          }
        })
      }
    }
    AccountService.get(AccountUserService.currentAccountUser.account).then(function (data) {
      $scope.accountObj = data;
    }).catch(function () {
      $scope.accountObj = null;
    });
    if ($scope.workflow.locale && $scope.getLocaleLength($scope.workflow) > 0) {
      let keys = Object.keys($scope.workflow.locale);
      if (!keys.includes('en')) {
        $scope.workflow.locale['en'] = { "name": $scope.workflow.name }
        $scope.localeAdded = true;
      }
    }
    
  } else {
    $scope.data = {
      notify_to: [''],
      contact_types: [],
      min_days_between_instances: 10,
      by_unit: false,
      is_unit_turn: false,
      unit_turn_type: null,
      trigger_wfs_on_finish: false,
      trigger_wf_types: null,
      role_based: {
        roles: [],
        role_based_only: false
      },
      seasonal: {
        from: null,
        to: null
      },
      days_before_ai_creation: 0,
      properties_data : {
        properties : [],
        portfolios : []
      },
      languages: ['2'],
      created_in_language: 'en',
      updated_in_language : 'en'
    };
    if (AccountService.getCollection().length > 1 && AuthDataService.isNotStaff()) {
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/account/select.html',
          controller: 'SelectAccountDialog',
          className: 'ngdialog-theme-default ngdialog-select-account',
          data: {
            permission: 'permission_add_workflow'
          }
        })
        .then(
          function (account) {
            if (!account) {
              window.history.back();
            }
            $scope.data.account = account !== 'all' ? account : null;
            $scope.accountUser = AccountUserService.getAccountUser($scope.data.account);
          },
          function () {
            window.history.back();
          }
        );
    } else {
      $scope.data.account = AccountUserService.currentAccountUser.account;
      $scope.accountUser = AccountUserService.getAccountUser($scope.data.account);
    }

    AccountService.get(AccountUserService.currentAccountUser.account).then(function (data) {
      $scope.accountObj = data;
    }).catch(function () {
      $scope.accountObj = null;
    });
  }

  $scope.data.by_unit = $state.current.by_unit;
  $scope.data.is_unit_turn = $scope.is_unit_turn;

  $scope.deleteTypes = function () {
    if (!$scope.data.trigger_wfs_on_finish) {
      $scope.data.trigger_wf_types = null;
    }
    if (!$scope.data.is_unit_turn) {
      $scope.data.unit_turn_type = null;
    }
  };

  $scope.toggleTab = function (tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    } else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function (tab) {
    return _.contains($scope.tabsCollapsed, tab);
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid || ($scope.data.allow_recurrence && $scope.by_unit && $scope.filter_conditions && $scope.filter_conditions.length === 0)) {
      FormErrorsService.goToError();
      return;
    }
    $scope.deleteTypes();
    var data = angular.copy($scope.data);
      data.trigger_wf_types = data.trigger_wf_types ? data.trigger_wf_types.split(',').map(Number) : null;
      delete data.role_based;
      if ($scope.data.role_based) {
        data['roles'] = $scope.data.role_based.roles;
        data['role_based_only'] = $scope.data.role_based.role_based_only;
      }
      if (data.min_days_between_instances < 0) {
        if ($state.current.by_unit) {
          NotificationService.error('Ensure Min days between Unit Workflows is greater than or equal to 0.');
        }
        else {
          NotificationService.error('Ensure Min days between Workflows is greater than or equal to 0.');
        }
        return false;
      }
      delete data.allow_recurrence;
      delete data.recurrence;
      delete data.properties_data;
      delete data.seasonal;
      if ($scope.data.allow_recurrence) {
        data['recurrence'] = $scope.data.recurrence.recurrence;
        data['recurrence_type'] = $scope.data.recurrence.type;
        data['recurrence']['bump_to_next_day_if_closed'] = $scope.data.recurrence.recurrence['bump_to_next_day_if_closed'];
        data['properties'] = $scope.data.properties_data.properties;
        data['portfolios'] = $scope.data.properties_data.portfolios;
         // at the time of creation recurrence will be enable by default
        data['recurrence_enable'] = true;
        if ($scope.data.seasonal) {
          data.date_from = $scope.data.seasonal.from ? $scope.data.seasonal.from : null;
          data.date_to = $scope.data.seasonal.to ? $scope.data.seasonal.to : null;
        }
        // need to update this line when I have updated BE code for unit workflow
        if ($scope.by_unit) {
          angular.forEach($scope.filter_conditions, function (condition) {
            condition.units = angular.isArray(condition.units) ? condition.units.map((item) => ({id : item.id, property: item.property, number: item.number})) : condition.units;
            if (condition.units_exclude) {
              condition.units_exclude = condition.units_exclude.map((item) => ({id : item.id, property: item.property, number: item.number}));
            }
          });
          data['units'] = $scope.filter_conditions;
        }
        $scope.alterData(data);
      }
      else {
        data['recurrence'] = null;
        data['recurrence_enable'] = false;
        delete data.recurrence_type;
        delete data.properties;
        delete data.portfolios;
        delete data.units;
        delete data.ignore_office_hours;
        delete data.date_from;
        delete data.date_to;
        delete data.fields;
        delete data.days_before_ai_creation;
      }
      // checking translations
      if($scope.data.languages){
        $scope.data.languages = angular.isArray($scope.data.languages) ? $scope.data.languages : $scope.data.languages.split(',');
      }
      // need to manage the languages when translation is off then language should be blank array
      if($scope.data.translation && $scope.data.languages && $scope.data.languages.length > 0){
        data.languages = $scope.data.languages.map(Number);
      }
      else {
        data.languages = [];
        delete data['created_in_language'];
        delete data['updated_in_language'];
      }
      if($scope.localeAdded){
        delete data.locale['en'];
      }
      delete data['translation'];

    if ($scope.action === 'edit') {
      $scope.workflow.patch(data).then(function () {
        if ($state.current.by_unit) {
          $state.go('unit-turn.workflows');
        } else {
          $state.go('workflows.workflows');
        }
      });
    } else {
      WorkFlowService.post(data).then(function (result) {
        WorkFlowService.updateCollection(result);
        if ($state.current.by_unit) {
          $state.go('unit-turn.workflows');
        } else {
          $state.go('workflows.workflows');
        }
      });
    }
  }

  $scope.alterData = function (data) {
    data.fields = {};
    angular.forEach($scope.field_data, function (value, key) {
      if (value) data.fields[key] = value;
    });
  };

  $scope.prepareFields = function () {
    $scope.fields_data = [];
    angular.forEach($scope.fieldSubgroups, function (subgroup) {
      if(subgroup.name.toLowerCase() == 'type'){
        $scope.fields_data.push(subgroup);
      }
    });
  };

  $scope.changeSelectedTab = function (lang) {
    $scope.data.updated_in_language = lang;
  }

  $scope.updateTranslations = function (field_name) {
    if ($scope.workflow.locale && Object.keys($scope.workflow.locale).length > 0 && ($scope.data.created_in_language == $scope.data.updated_in_language)) {
      let translate_lang = Object.keys($scope.workflow.locale).filter(key => (key != $scope.data.updated_in_language));
      let context = { id: field_name, value: $scope.workflow.locale[$scope.data.updated_in_language][field_name] }
      let request = {
        original_lang: $scope.data.updated_in_language,
        translate_lang: (translate_lang && translate_lang.length > 0) ? translate_lang : ['en'],
        context: context
      }
      TranslationService.post(request).then(function (result) {
        if (result && result.context && result.context.length > 0) {
          result.context.forEach(translated_data => {
            translated_data.forEach(loc => {
              Object.keys(loc).forEach(lang_code => {
                $scope.data.locale[lang_code][field_name] = loc[lang_code]['value'];
              })
            })
          })
          $scope.data[field_name] = $scope.data.locale['en'][field_name];
        }
      })
    }
  }

  // if we are creating unit workflow then only below line of code should be executed
  if($scope.by_unit && $scope.checkEnableScheduling()){
    $scope.$watch('data.properties_data', function (newValue, oldValue) {
      if($scope.data.properties_data){
        $scope.propertiesList = [...newValue.properties];
      }
      $scope.loadPage();
    }, true);

    $controller('WorkFlowUnitSelectDialog', { $scope: $scope });
  }
  
  FieldSubgroupService.getlist({
    disable_pagination: true,
    sector: $scope.authDataService.authData.account ? $scope.authDataService.authData.account.sector : ''
  }).then(function(data){
    $scope.fieldSubgroups = data;
    $scope.prepareFields();
  });

};

app.controller('WorkFlowForm', [
  '$scope',
  '$rootScope',
  '$state',
  '$filter',
  'workflowOjb',
  'WorkFlowService',
  'AccountUserService',
  'ngDialog',
  'NotificationService',
  'FormErrorsService',
  'AccountService',
  'AuthDataService',
  'PermissionService',
  '$controller',
  'FieldSubgroupService',
  'FilterService',
  'TranslationService',
  WorkFlowForm
]);
